import { Button, Typography,Grid } from "antd";
import React, { useEffect, useState } from "react";
import { formatString } from "../Common/ColorCode";
import moment from "moment";
import { ArrowLeftOutlined, SearchOutlined } from "@ant-design/icons";
import ClinicMap from "./ClinicMap";
import { capitalizeFirst, filterByNonGpProductId } from "../Common/CommonFunction";
import "./BookingForm.css"

const { Title } = Typography;


let tempData = {
  product: "General GP consultation",
  data: [
    {
      key: "Duration",
      data: "15 minutes",
    },
    {
      key: "Language",
      data: "Arabic",
    },
    {
      key: "Gender",
      data: "Male",
    },
    {
      key: "Gender",
      data: "Male",
    },
  ],
  date: "14 January, 2025",
  time: "10:30",
  name: "Oxford Street",
  address: "6 Newburgh Street, Carnaby, London, W1F 7RQ",
};

const BookingDetailsNext = (props) => {
  
      const { useBreakpoint } = Grid;
        const screens = useBreakpoint();

  const [buttonopen ,setButtonOpen]=useState(true)

  useEffect(() => {
    setButtonOpen(true)
  },[props?.hide])

  // console.log("::::::BookingDetailsNext:::::", props);
  let tempDataForDuration = [];
  // useEffect(() => {
  // console.log('::::::useEffect:::::', props.showAppoinmentData.duration)
  if (props.showAppoinmentData && props.showAppoinmentData.duration) {
    tempDataForDuration.push({
      key: "Duration",
      data:
        props.data &&
        props.data.durationObjectById &&
        props.showAppoinmentData.duration &&
        props.data.durationObjectById[props.showAppoinmentData.duration]
          ? props.data.durationObjectById[props.showAppoinmentData.duration]
              .duration + " minutes"
          : "15 minutes",
    });
  }

  if (props.showAppoinmentData && props.showAppoinmentData.price) {
    tempDataForDuration.push({
      key: "Price",
      data: props.showAppoinmentData.price
        ? capitalizeFirst(props.showAppoinmentData.price)
        : "",
    });
  }
  if (props.showAppoinmentData && props.showAppoinmentData.language) {
    let data = "";
    if (
      props.showAppoinmentData.language &&
      props.showAppoinmentData.language.value
    ) {
      data = props.showAppoinmentData.language.value;
    } else {
      data = props.showAppoinmentData.language;
    }
    // console.log('languageName dfd', props.data.languageData)
    let languageName = props.data.languageData.find(
      (landata) => landata.value == data
    );
    // console.log('languageName dfd',languageName)
    tempDataForDuration.push({
      key: "Language",
      data: languageName ? languageName.label : data,
    });
  }
  if (props.showAppoinmentData && props.showAppoinmentData.gender) {
    tempDataForDuration.push({
      key: "Gender",
      data: props.showAppoinmentData.gender
        ? capitalizeFirst(props.showAppoinmentData.gender)
        : "",
    });
  }
  
  // console.log("tempDataForDuration", tempDataForDuration)

  // }, [props])
  // console.log('tempDataForDuration', tempDataForDuration)


  function getProductName(id) {
    let products;
  
    // Try to load from localStorage and parse to object
    const stored = localStorage.getItem('nongroupproductid');
    if (stored) {
      try {
        products = JSON.parse(stored); // parse string to object
      } catch (e) {
        console.error("Invalid JSON in localStorage");
        products = {}; // fallback to empty object on error
      }
    } else {
      // Fallback if nothing in localStorage
      products = {
        201: "Vital",
        202: "Bronze",
        203: "Silver",
        204: "Gold",
        205: "Platinum",
        4: "Vital (15 minutes)",
        5: "Bronze (60 minutes)",
        6: "Gold (90 minutes)",
        7: "Silver (75min)",
        10: "Platinum",
        18: "r888",
        20: "r888178",
        22: "Diamond"
      };
    }
  
    // console.log("productsproductsproducts", products, typeof products);
    return products[id];
  }


  const rawDate = props?.showAppoinmentData?.slot?.date;

// const formattedDateForIPHONE = rawDate
//   ? new Date(rawDate.replace(/([A-Za-z]{3})(\d{4})/, '$1 $2'))
//       .toLocaleDateString('en-GB', {
//         day: 'numeric',
//         month: 'long',
//         year: 'numeric',
//       }) 
//   : '';

const formattedDateForIPHONE = rawDate
  ? moment(rawDate.replace(/([A-Za-z]{3})(\d{4})/, '$1 $2'), "ddd, D MMM YYYY"   // Explicit format is key
    ).format("D MMMM, YYYY")
  : '';



  

  return (
    <div>
      {/* Appointment data duration language gender price  */}
      <div style={{ display: "grid", justifyContent: "center",marginBottom:"20px" }}>
        <div
        className="widthSet"
          style={{
            // maxWidth: "440px",
            background: "#F0FAFA",
            padding:screens.md? 10 : "10px 0px ",
            paddingBlock : 10,
            marginTop:screens.md? 20:10,
            border: "1px solid #008385",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            gap: "6px",
            height: "auto",
          }}
        >
          <span style={{  fontSize: 14, color: "#008385", }}>
            {" "}
            {props?.showAppoinmentData &&
            props?.showAppoinmentData.clinic &&
            props?.showAppoinmentData.clinic?.productCategory &&
            props?.showAppoinmentData.clinic?.productCategory?.title
              ? props?.showAppoinmentData.clinic?.productCategory?.title
              : "GP appointment"}
          </span>
          {/* {props?.showAppoinmentData &&
            props?.showAppoinmentData.clinic &&
            props?.showAppoinmentData.clinic?.productCategory &&
            props?.showAppoinmentData.clinic?.productCategory
              ?.product_category_id == 2 && <br />} */}
          {/* {props?.showAppoinmentData &&
            props?.showAppoinmentData.clinic &&
            props?.showAppoinmentData.clinic?.productCategory &&
            props?.showAppoinmentData.clinic?.productCategory
              ?.product_category_id == 2 && (
              <span style={{ margin: 0, fontSize: 14, color: "#008385" }}>
                {" "}
                {props?.showAppoinmentData &&
                props?.showAppoinmentData.clinic &&
                props?.showAppoinmentData.clinic?.productCategory &&
                props?.showAppoinmentData.clinic?.productCategory
                  ?.product_category_id == 2 &&
                props?.showAppoinmentData.clinic.non_gp_product_id &&
                props.getAllHealthScreenData &&
                props.getAllHealthScreenData.getAllHealthScreenData.data
                  ? filterByNonGpProductId(
                      props.getAllHealthScreenData.getAllHealthScreenData.data,
                      props?.showAppoinmentData.clinic.non_gp_product_id
                    )?.length &&
                    filterByNonGpProductId(
                      props.getAllHealthScreenData.getAllHealthScreenData.data,
                      props?.showAppoinmentData.clinic.non_gp_product_id
                    )[0].name
                  : ""}
              </span>
            )} */}
          {/* <br /> */}
          {/* {tempDataForDuration && tempDataForDuration.length
            ? tempDataForDuration?.map((rs, i) => {
                return (
                  <>
                    <span style={{ color: "#000", fontSize: 13 }}>
                      {rs.key}:
                    </span>
                    <span style={{ fontSize: 13, color: "#008385" }}>
                      {" "}
                      {rs.data} {tempData.data.length == i + 1 ? "" : " | "}
                    </span>
                  </>
                );
              })
            : ""} */}

          {!props?.showAppoinmentData?.clinic?.non_gp_product_id ? (
            tempDataForDuration && tempDataForDuration.length ? (
              <div>
                {[0, 2].map((startIdx) => {
                  const filteredItems = tempDataForDuration
                    .slice(startIdx, startIdx + 2)
                    .filter(
                      (rs) =>
                        !(
                          (rs.key === "Language" && rs.data.toLowerCase() === "english") ||
                          (rs.key === "Gender" && rs.data.toLowerCase() === "no_preference")
                        )
                    );

                  return (
                    <div key={startIdx}>
                      {filteredItems.map((rs, i) => (
                        <React.Fragment key={i}>
                          <span style={{ color: "#4A4A4A", fontSize: 13 }}>{rs.key}:</span>
                          <span style={{ fontSize: 13, color: "#008385" }}>
                            {" "}
                            {rs.data}
                          </span>
                          {i !== filteredItems.length - 1 && (
                            <span style={{ color: "#4A4A4A" }}> | </span>
                          )}
                        </React.Fragment>
                      ))}
                    </div>
                  );
                })}
              </div>

            ) : null
          ) : (
            props?.showAppoinmentData.clinic?.productCategory
              ?.product_category_id  == 2 ? (
                <span style={{ color: "#008385", fontSize: 13 }}>
                  {getProductName(props?.showAppoinmentData?.clinic?.non_gp_product_id)} {" | "}
                  {`Price: ${props?.showAppoinmentData?.price} `}
                </span>                
              ) : ( null)

          )}

        </div>
        {/* Date section */}
        <div
        className="widthSet"
          style={{
            // maxWidth: "440px",
            background: "#F0FAFA",
            padding:screens.md? 10 : 0,
            border: "1px solid #008385",
            borderTop:"0",
            height: 61,
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            margin:"auto"
          }}
        >
          
          <span style={{ margin:"auto",fontWeight:"500", fontSize: 20, color: "rgba(74, 74, 74, 1)" }}>
            {props?.showAppoinmentData &&
            props?.showAppoinmentData.slot &&
            // props.showAppoinmentData.slot?.date
            //   ? moment(`${props.showAppoinmentData.slot?.date} 2025`).format(
            //       "D MMMM, YYYY"
            //     )
            //   : ""}{" "}
            // |{" "}
            
            props?.showAppoinmentData && props?.showAppoinmentData.slot && props.showAppoinmentData.slot?.date 
              // ? moment(props.showAppoinmentData.slot?.date).format("D MMMM, YYYY")  + "hello"
              ? formattedDateForIPHONE
              : ''} 
            {" "} |{" "}
            {props?.showAppoinmentData &&
            props?.showAppoinmentData.slot &&
            props.showAppoinmentData.slot.info &&
            props.showAppoinmentData.slot.info.start_time
              ? props.showAppoinmentData.slot.info.start_time
              : ""}
          </span>
        </div>
        <div
          className=" "
          style={{
            maxWidth:screens.md? "440px" : "93vw",
            display: "flex",
            justifyContent: "flex-start",
            marginTop: 20,
            // marginLeft:"0px",
            // "@media (max-width: 350px)": {
            //   marginLeft: "10px",
            // },
            // margin:"15px",
            // marginLeft : "0px" 
          }}
        >
          <div
            style={{
              width: 90,
              height: 90,
              borderRadius: "10px",
              // marginLeft: 1,
            }}
          >
            {/* <iframe
                            width={76}
                            height={76}
                            style={{ border: "0", marginTop: 0 }}
                            loading="lazy"
                            // allowFullScreen
                            src={`https://www.openstreetmap.org/export/embed.html?bbox=${props.showAppoinmentData?.slot?.clinicData?.longitude},${props.showAppoinmentData?.slot?.clinicData?.latitude},${props.showAppoinmentData?.slot?.clinicData?.longitude},${props.showAppoinmentData?.slot?.clinicData?.latitude}&layer=mapnik`}
                        ></iframe> */}
            <ClinicMap
              widthAndheight={{ width: 90, height: 90 }}
              passData={{
                cood: [
                  {
                    id: props.showAppoinmentData?.slot?.clinicData?.id,
                    name: props.showAppoinmentData?.slot?.clinicData?.name,
                    data: [
                      props.showAppoinmentData?.slot?.clinicData?.latitude,
                      props.showAppoinmentData?.slot?.clinicData?.longitude,
                    ],
                  },
                ],
              }}
            />
          </div>
          <div style={{ textAlign: "left", marginLeft: 30 }}>
            <p style={{ fontSize: 14, marginTop:0 }}>
              {props.showAppoinmentData?.slot?.clinicData?.name
                ? props.showAppoinmentData.slot.clinicData.name
                : ""}
            </p>
            <p style={{ fontSize: 14 }}>
              {props.showAppoinmentData?.slot?.clinicData?.address
                ? props.showAppoinmentData?.slot?.clinicData?.address
                : ""}
            </p>
          </div>
        </div>
      </div>
      {/* {!props?.hide && ( */}

       { buttonopen?
        <div
          style={{ display: "flex", justifyContent: "center", marginTop: 30}}
        >
          <Button
            shape="square"
            icon={
              <ArrowLeftOutlined
                // onClick={props.callBackForbackpage("booking")}
                style={{ color: "#008385", fontSize: "18px" }}
              />
            }
            style={{
              backgroundColor: "#C8E6E6", // Light teal
              border: "none",
              width: "40px",
              height: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: 0,
              marginRight: 10,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              position:"absolute",
              left:"14px"
            }}
            onClick={() =>{
              // console.log("hello from button")
              props.callBackForbackpage(
                props.showAppoinmentData.type
                  ? props.showAppoinmentData.type
                  : "BookingForm"
              )
            }
            }
          />
          <Button
            onClick={() =>{
              props.callback({ nexData: "data" }, "BookingDetailsNext");setButtonOpen(!buttonopen)
            }}
            type="primary"
            style={{
              background: "#008385",
              borderColor: "#008385",
              width: 182,
              height: 40,
              // marginRight: 30,
            }}
          >
            Continue
          </Button>
        </div>:""}
      {/* )} */}
    </div>
  );
};

export default BookingDetailsNext;
